import CircleLoader from "app/components/loader/CircleLoader";
import { tierData } from "app/config";
import { useTheme } from "app/shared";
import Down from "assets/img/icons/Down.svg";
import Star from "assets/img/icons/Star1.svg";
import Up from "assets/img/icons/Up.svg";
import InfoIcon from "assets/img/icons/iIcon.svg";
import React, { useEffect, useState } from "react";
import styles from "./tier-widget.module.scss";

type TierWidgetProps = {
  userTier?: string;
  isLoading: boolean;
};

const TierWidget: React.FC<TierWidgetProps> = ({ userTier, isLoading }) => {
  const [activeTier, setActiveTier] = useState<string | null>(userTier || null);
  const { theme } = useTheme();

  useEffect(() => {
    setActiveTier(userTier || null);
  }, [userTier]);

  const getProgressBarPercentage = (tier: string) => {
    switch (tier) {
      case "Alpha":
        return 95;
      case "Beta":
        return 85;
      case "Gamma":
        return 60;
      case "Beginner":
      default:
        return 30;
    }
  };

  if (isLoading) {
    return (
      <div
        className={`${styles.tierWidget} ${
          theme === "dark" ? styles.darkTheme : ""
        }`}
      >
        <CircleLoader colorType="dark" isLoading={isLoading} />
      </div>
    );
  }

  return (
    <div
      className={`${styles.tierWidget} ${
        theme === "dark" ? styles.darkTheme : ""
      }`}
    >
      <div className={styles.header}>
        <h1>Higher Tier</h1>
        <p>Higher Rewards & Allocations</p>
      </div>
      <div className={styles.content}>
        <div className={styles.tierList}>
          {tierData.map((tier, index) => (
            <div
              key={index}
              className={`${styles.tier} ${
                activeTier === tier.tierKey ? styles.active : ""
              }`}
              onClick={() => setActiveTier(tier.tierKey)}
            >
              <div className={styles.tierHeader}>
                <span className={styles.tierName}>
                  {tier.name}
                  {userTier === tier.tierKey && (
                    <span className={styles.myTier}>My Tier</span>
                  )}
                </span>
                <button className={styles.toggleButton}>
                  {activeTier === tier.tierKey ? (
                    <img src={Up} alt="up" />
                  ) : (
                    <img src={Down} alt="down" />
                  )}
                </button>
              </div>
              <div
                className={`${styles.tierContent} ${
                  activeTier === tier.tierKey ? styles.active : ""
                }`}
              >
                <p>
                  <span>{tier.punch}</span>
                  {tier.first}
                </p>
                <p>
                  <img src={Star} alt="star" />
                  {tier.second}
                  <span className={styles.tooltipContainer}>
                    <img
                      src={InfoIcon}
                      alt="info"
                      className={styles.infoIcon}
                    />
                    <span className={styles.tooltipText}>{tier.tooltip}</span>
                  </span>
                </p>
                <p>
                  <img src={Star} alt="star" />
                  {tier.third}
                </p>
                <p>
                  <img src={Star} alt="star" />
                  {tier.four}
                </p>
                {tier.five && (
                  <p>
                    <img src={Star} alt="star" />
                    {tier.five}
                  </p>
                )}
                {tier.six && (
                  <p>
                    <img src={Star} alt="star" />
                    {tier.six}
                  </p>
                )}
                {tier.seven && (
                  <p>
                    <img src={Star} alt="star" />
                    {tier.seven}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
        <div className={styles.progressSection}>
          <div
            className={`${styles.percentageLabels} ${
              theme === "dark" ? styles.darkTheme : ""
            }`}
          >
            <span>95%</span>
            <span>80%</span>
            <span>40%</span>
            <span>0%</span>
          </div>
          <div className={styles.progressBar}>
            <div
              className={styles.progress}
              style={{
                height: `${userTier ? getProgressBarPercentage(userTier) : 0}%`,
              }}
            />
            <div
              className={`${styles.tierMarkers} ${
                theme === "dark" ? styles.darkTheme : ""
              }`}
            >
              <span className={styles.tierMarker} style={{ top: "7%" }}>
                Tier 1
              </span>
              <span className={styles.tierMarker} style={{ top: "25%" }}>
                Tier 2
              </span>
              <span className={styles.tierMarker} style={{ top: "50%" }}>
                Tier 3
              </span>
              <span className={styles.tierMarker} style={{ top: "76%" }}>
                Tier 4
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TierWidget;
